import uniq from 'lodash/uniq';

import { BaseEntityInput } from '@/modules/entity-management/types';

const MAX_LISTED_PROBLEMS = 5;

/** Problems across one entity's producers that refuse the whole file before anything is sent.
 *
 * Only what the API refuses on every save is checked here. The portal's other rules (a default, distinct
 * emails, no contact email, a coverage type on one producer) apply only to lists a file changes, which
 * the API tells apart by comparing with the stored list, so it applies them per entity. */
export function findProducerProblems(entities: BaseEntityInput[]): string[] {
    return entities.flatMap((entity) => {
        const producers = entity.producerList || [];
        const name = entity.displayName || entity.contactEmail;
        return producers.filter((producer) => producer.isDefault === true).length > 1
            ? [ `${name}: more than one producer is marked as the default.` ]
            : [];
    });
}

export function describeProducerProblems(problems: string[]): string {
    const listed = problems.slice(0, MAX_LISTED_PROBLEMS).join(' ');
    const remaining = problems.length - MAX_LISTED_PROBLEMS;
    return remaining > 0 ? `${listed} And ${remaining} more.` : listed;
}

export function collectProducerEmails(entities: BaseEntityInput[]): string[] {
    return uniq(entities.flatMap((entity) => (entity.producerList || [])
        .map((producer) => (producer.email || '').trim())
        .filter(Boolean)));
}
